import React from "react";
import Link from "gatsby-link";

import {
  Jumbotron,
  Grid,
  Row,
  Col,
  Image,
  Button,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Tabs,
  Tab,
  TabContainer,
  TabContent,
  TabPane
} from "react-bootstrap";
import AltHeader from "../../components/alt-header.js";
import UpNext from "../../components/up-next.js";
import Layout from "../../components/Layout.js";
import Job from "../../components/job.js";
import JobHeader from "../../components/job-header.js";
import smokinVideo from "../../img/smokin-mirrors/smokin.mp4";
import smokinHero from "../../img/smokin-hero.jpg";
import prepPlusCard from "../../img/prep-card.png";
import superdrugCard from "../../img/superdrug-mobile-card.jpg";
import smokinPoster from "../../img/smokin-poster.png";
const MarionnaudPage = () => (
  <Layout>
    <JobHeader
      image={smokinHero}
      title="Smokin Mirrors"
      subtitle="Transforming hair brands from root to tip"
      text="Interactive Design / Development"
    />

    <Row className="show-grid side-padding intro">
      <Col xs={12} sm={10} smOffset={2} md={12} mdOffset={2}>
        <h2>My Role</h2>
        <p className="job-text">
            My role in this project was to take a flat design and turn it into an interactive experience. The brief was to create a mysterious effect. I used webGL to create a smoke effect that followed the mouse and animated each element with a subtle fade based on the scroll. I included full height sliding animations to break the page up and create a more engaging experience.
        </p>
      </Col>
    </Row>

    <Row className="show-grid">
    <Col xs={12} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
        <video
          width="100%"
          height="100%"
          src={smokinVideo}
          controls
          poster={smokinPoster}
        />
      </Col>
    </Row>


    <UpNext
      image1={prepPlusCard}
      title1="Preparation Plus"
      text1="Digital pre-skilling, reskilling, and upskilling websites"
      url1="/preparation-plus/"
      image2={superdrugCard}
      title2="Superdrug Mobile"
      text2="Creating a mobile brand from scratch"
      url2="/superdrug-mobile/"
      image3="/img/spread-co-card.jpg"
      title3="Spread Co"
      text3="A financial spread betting company"
      url3="/spread-co/"
    />
  </Layout>
);

export default MarionnaudPage;
